<template>
  <div class="card mgt-20px">
    <header class="header-card" >
      <p>{{ $t('editCheminFer.infosParution.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-2">
          <div class="is-italic has-text-default">
            {{ $t('detailParution.information.code') }}
          </div>
          <div class="has-text-weight-semibold">
            <router-link-blank
              :to="{
                name: 'c.presse.parution',
                params: { id: parution.id } }"
              :message="parution.code">
            </router-link-blank>
          </div>
        </div>
        <div class="column is-2">
          <div class="has-text-default is-italic">
            {{ $t('detailParution.information.nomSupport') }}
          </div>
          <div class="has-text-weight-semibold">
            {{ parution.nomSupport }}
          </div>
        </div>
        <div class="column is-2">
          <div class="has-text-default is-italic">
            {{ $t('detailParution.information.nomParution') }}
          </div>
          <div class="has-text-weight-semibold">
            {{ parution.nomParution }}
          </div>
        </div>
        <div class="column is-2">
          <div class="is-italic has-text-default">
            {{ $t('detailParution.information.numParution') }}
          </div>
          <div class="has-text-weight-semibold">
            {{ parution.numParution }}
          </div>
        </div>
        <div class="column is-2">
          <div class="is-italic has-text-default">
            {{ $t('detailParution.information.dateParution') }}
          </div>
          <div class="has-text-weight-semibold">
            {{ formatDate(parution.dateParution) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import formatDate from '@/services/general/formatDate';

export default {
  name: 'InfosParution',
  props: {
    parution: {
      type: Object,
      required: true,
    },
  },
  components: {
    RouterLinkBlank,
  },
  methods: {
    formatDate(date) {
      return formatDate(date);
    },
  },
};
</script>
